import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
import {
  brandMark,
  channelGlyph,
  CHANNEL_COLORS,
  CHANNEL_ICONS,
  LOGO_ACCEPT,
  LOGO_FOLDER,
  LOGO_MAX_SIZE,
} from "../../components/marketing_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
// ใช้ตาราง/ชิปชุดเดียวกับหน้าประเภททรัพย์ (pty-rank, pty-code, pty-desc, pty-picker)
// เพราะเป็นหน้า master แบบเดียวกัน จะได้หน้าตาตรงกันโดยไม่ต้องเขียนสไตล์ซ้ำ
import "../../assets/css/property_type.css";
import "../../assets/css/marketing.css";

/* ============================================================================
 * การตลาด › จัดการช่องทาง  (/ad/marketing/channels)
 *
 * ข้อมูล master ของเมนูการตลาด — ช่องทางที่เปิดใช้งานที่นี่คือ
 *   · ตัวหารของ "ความคืบหน้า" ในหน้าคิวงาน (เช่น 4/7)
 *   · รายการที่ให้ติ๊กตอนบันทึกการโพสต์
 *   · ตัวเลือกในตัวกรอง "ช่องทาง"
 *
 * รายการมีไม่มากและต้องเห็นลำดับทั้งชุดพร้อมกันเพื่อจัดเรียงขึ้น-ลง จึงแสดงเป็น
 * ตารางเดียวจบ ไม่มีตัวกรองและไม่แบ่งหน้า (แนวเดียวกับหน้าประเภททรัพย์)
 *
 * ช่องทางที่มีประวัติการโพสต์แล้วจะลบไม่ได้ — ให้ปิดใช้งานแทน ประวัติจะได้ไม่กำพร้า
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/marketing-channels           (Get — page: 0 = เอาทั้งหมด)
 *   POST   admin/marketing-channels           (Save — สร้าง)
 *   PUT    admin/marketing-channels/:uid      (Save — แก้ไข / ToggleActive)
 *   PUT    admin/marketing-channels/:uid/move (Move — สลับลำดับกับรายการข้างเคียง)
 *   DELETE admin/marketing-channels/:uid      (Delete)
 * ========================================================================== */

const EMPTY_FORM = {
  name_th: "",
  name_en: "",
  code: "",
  logo_url: "", // มีค่า = ใช้รูปที่อัปโหลดแทนไอคอน/สี
  color: CHANNEL_COLORS[0],
  icon: CHANNEL_ICONS[0],
  url: "",
  description: "",
  is_active: true,
};

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US");
const displayName = (item) => (isTh() ? item.name_th : item.name_en || item.name_th);
const secondName = (item) => (isTh() ? item.name_en : item.name_th);

/* รหัสอ้างอิงต้องเป็น a-z 0-9 และ _ เท่านั้น เพราะถูกใช้เลือกโลโก้แบรนด์
   และถูกอ้างในบันทึกการโพสต์ที่ลงไปแล้ว */
const CODE_PATTERN = /^[a-z][a-z0-9_]*$/;
const toCode = (value) => String(value).toLowerCase().replace(/[^a-z0-9_]/g, "");

class MarketingChannels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],

      modal_form: false,
      edit_uid: "", // ว่าง = โหมดเพิ่มช่องทางใหม่
      form: { ...EMPTY_FORM },
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* ------------------------------------------------------ ดึงรายการช่องทาง */
  Get = async () => {
    loading(true);
    const result = await GET("admin/marketing-channels", { page: 0 }); // ดึงทั้งหมด ไม่แบ่งหน้า
    loading(false);

    if (!result?.status) return;

    this.setState({ items: result.data || [] });
  };

  /* เรียงตามลำดับที่ตั้งไว้เสมอ — ลำดับนี้คือลำดับที่ชิปช่องทางเรียงในหน้าคิวงาน */
  ordered = () => [...this.state.items].sort((a, b) => a.sort - b.sort);

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* --------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ไข */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        name_th: item.name_th || "",
        name_en: item.name_en || "",
        code: item.code || "",
        logo_url: item.logo_url || "",
        color: item.color || CHANNEL_COLORS[0],
        icon: item.icon || CHANNEL_ICONS[0],
        url: item.url || "",
        description: item.description || "",
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* ------------------------------------------------------------ บันทึกข้อมูล */
  Save = async () => {
    const { form, edit_uid, items } = this.state;
    const code = toCode(form.code);

    if (!form.name_th.trim()) return alert("", "warning", t("warning"), t("mkc_verify_name_th"));
    if (!code) return alert("", "warning", t("warning"), t("mkc_verify_code"));
    if (!CODE_PATTERN.test(code)) return alert("", "warning", t("warning"), t("mkc_verify_code_format"));
    if (items.some((item) => item.code === code && item.uid !== edit_uid))
      return alert("", "warning", t("warning"), t("mkc_verify_code_duplicate"));

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    const body = {
      name_th: form.name_th.trim(),
      name_en: form.name_en.trim(),
      code,
      // ส่ง logo_url ไปเสมอ — สตริงว่างคือคำสั่งล้างรูปทิ้งแล้วกลับไปใช้ไอคอน/สี
      logo_url: form.logo_url,
      color: form.color,
      icon: form.icon,
      url: form.url.trim(),
      description: form.description.trim(),
      is_active: form.is_active,
    };

    loading(true);
    const result = !edit_uid
      ? await POST("admin/marketing-channels", body)
      : await PUT("admin/marketing-channels/" + edit_uid, body);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get();
    alert("", "success", t("success"), edit_uid ? t("save_done") : t("mkc_add_done"));
  };

  /* -------------------------------------------------------- เปิด/ปิดใช้งาน */
  ToggleActive = async (item) => {
    const next = !item.is_active;
    const detail = next ? t("mkc_enable_confirm") : t("mkc_disable_confirm");
    if (!(await alert("", "info", next ? t("mkc_enable") : t("mkc_disable"), `${detail}\n${displayName(item)}`, t("confirm"), t("cancel"))))
      return;

    loading(true);
    const result = await PUT("admin/marketing-channels/" + item.uid, { is_active: next });
    loading(false);

    if (!result?.status) return;

    await this.Get();
    alert("", "success", t("success"), next ? t("mkc_enable_done") : t("mkc_disable_done"));
  };

  /* ---------------------------------------------------------- สลับลำดับแสดงผล */
  /* backend สลับ sort กับรายการที่อยู่ติดกันให้ใน transaction เดียว
     ยิงครั้งเดียวจบ ไม่เกิดจังหวะที่ลำดับซ้ำกันระหว่างทาง */
  Move = async (item, step) => {
    const result = await PUT("admin/marketing-channels/" + item.uid + "/move", {
      direction: step < 0 ? "up" : "down",
    });
    if (!result?.status) return;

    await this.Get();
  };

  /* ------------------------------------------------------------------- ลบ */
  Delete = async (item) => {
    // ช่องทางที่เคยถูกใช้บันทึกการโพสต์ ลบไม่ได้ — บอกตั้งแต่ตอนกดจะได้ไม่ต้องรอ error จาก API
    if (item.post_count) {
      return alert("", "warning", t("warning"), `${t("mkc_delete_blocked")}\n${num(item.post_count)} ${t("mk_unit_posts")}`);
    }

    if (!(await alert("", "warning", t("delete_item"), `${t("mkc_delete_desc")}\n${displayName(item)}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/marketing-channels/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get();
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ------------------------------------------------------------- โลโก้ช่องทาง */

  /* อัปโหลดขึ้น storage ทันทีแล้วเก็บเป็น URL — ไม่เก็บ base64 ลงฐานข้อมูล
     เหมือนรูปทรัพย์และรูปหน้าแรก payload ตอนบันทึกจะได้ไม่บวมโดยไม่จำเป็น */
  PickLogo = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;

    if (!file.type?.startsWith("image/")) return alert("", "warning", t("warning"), t("mkc_verify_logo_type"));
    if (file.size > LOGO_MAX_SIZE) return alert("", "warning", t("warning"), t("mkc_verify_logo_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: LOGO_FOLDER });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }

    this.setForm({ logo_url: result.data.file_path });
  };

  /* ล้างรูปทิ้ง = กลับไปใช้โลโก้แบรนด์/ไอคอน+สีแบบเดิม
     ไม่ลบไฟล์บน storage เพราะช่องทางอื่นอาจเคยชี้ไฟล์เดิมไว้ (เช่น ทำสำเนาช่องทาง) */
  ClearLogo = () => this.setForm({ logo_url: "" });

  /** เครื่องหมายของช่องทาง — ใช้ตัวเดียวกับหน้าคิวงาน จะได้ไม่หลุดกันเวลาเปลี่ยนกติกา */
  glyph = (item) => channelGlyph(item, displayName(item));

  /* ==================================================== render : ตารางรายการ */
  renderTable = () => {
    const list = this.ordered();
    const active = this.state.items.filter((item) => item.is_active).length;

    return (
      <div className="prop-card prop-in">
        {/* หัวกล่อง — จำนวนช่องทางที่เปิดใช้งานคือตัวหารของความคืบหน้าในหน้าคิวงาน จึงเน้นตัวเลขนี้ */}
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("mkc_list_title")}
          </span>
          <div className="d-flex align-items-center gap-2">
            <span className="ppl-pill ppl-pill--ghost">
              {num(list.length)} {t("mkc_unit_channels")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {num(active)} {t("active")}
            </span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="ppl-table" style={{ minWidth: "920px" }}>
            <thead>
              <tr>
                <th style={{ width: "96px" }}>{t("ptype_sort")}</th>
                <th style={{ width: "268px" }}>{t("mkc_col_channel")}</th>
                <th>{t("description")}</th>
                <th className="text-center" style={{ width: "132px" }}>{t("mkc_col_usage")}</th>
                <th style={{ width: "132px" }}>{t("mkc_col_last_post")}</th>
                <th className="text-center" style={{ width: "104px" }}>{t("status")}</th>
                <th className="text-center" style={{ width: "112px" }}>{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={item.uid} className={item.is_active ? "" : "is-off"}>
                  {/* ลำดับ + ปุ่มเลื่อนขึ้น-ลง */}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span className="pty-rank">{item.sort}</span>
                      {/* สลับลำดับ = แก้ข้อมูล เลขลำดับยังโชว์ให้คนที่ดูอย่างเดียวเห็น */}
                      {can("marketing-channels.update") && (
                        <div className="mk-sortbtns">
                          <button
                            type="button"
                            className="mk-sortbtn icon"
                            title={t("ptype_move_up")}
                            disabled={index === 0}
                            onClick={() => this.Move(item, -1)}
                          >
                            {""}
                          </button>
                          <button
                            type="button"
                            className="mk-sortbtn icon"
                            title={t("ptype_move_down")}
                            disabled={index === list.length - 1}
                            onClick={() => this.Move(item, 1)}
                          >
                            {""}
                          </button>
                        </div>
                      )}
                    </div>
                  </td>

                  {/* โลโก้ + ชื่อ + รหัสอ้างอิง */}
                  <td>
                    <div className="d-flex align-items-center gap-3">
                      <div className="mk-ch-swatch" style={{ "--mk-chan-color": item.color || "#9ca3af" }}>
                        {this.glyph(item)}
                      </div>
                      <div className="min-w-0">
                        <div className="ppl-name text-truncate">{displayName(item)}</div>
                        <div className="ppl-sub d-flex align-items-center gap-2">
                          <span className="pty-code">{item.code}</span>
                          <span className="text-truncate">{secondName(item)}</span>
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* คำอธิบาย + ลิงก์ตั้งต้น */}
                  <td>
                    <div className={`pty-desc ${item.description ? "" : "text-secondary"}`}>
                      {item.description || t("mkc_no_description")}
                    </div>
                    {!!item.url && (
                      <a className="ppl-sub d-inline-flex align-items-center gap-1 mt-1" href={item.url} target="_blank" rel="noreferrer">
                        <span className="icon text-10">{""}</span>
                        <span className="text-truncate" style={{ maxWidth: "260px" }}>{item.url}</span>
                      </a>
                    )}
                  </td>

                  {/* จำนวนโพสต์ที่ลงช่องทางนี้ — บอกว่าช่องไหนถูกใช้จริง ช่องไหนตั้งไว้เฉย ๆ */}
                  <td className="text-center">
                    <div className="fw-bold text-dark">{num(item.post_count)}</div>
                    <div className="ppl-sub">{t("mk_unit_posts")}</div>
                  </td>

                  <td className="text-secondary text-12">
                    {item.last_posted_at ? format_date(item.last_posted_at, "dd mmm yyyy", locale()) : "-"}
                  </td>

                  {/* สถานะ */}
                  <td className="text-center">
                    {/* เปิด/ปิดใช้งาน = การแก้ข้อมูล */}
                    {can("marketing-channels.update") && (
                      <label className="ppl-switch" title={item.is_active ? t("mkc_disable") : t("mkc_enable")}>
                        <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                        <span className="ppl-switch__track" />
                      </label>
                    )}
                    <div className={`ppl-sub mt-1 fw-bold ${item.is_active ? "text-success" : ""}`}>
                      {item.is_active ? t("active") : t("inactive")}
                    </div>
                  </td>

                  {/* จัดการ */}
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      {can("marketing-channels.update") && (
                        <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                          {""}
                        </button>
                      )}
                      {can("marketing-channels.delete") && (
                        <button
                          type="button"
                          className="prop-iconbtn icon"
                          style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                          title={t("delete")}
                          onClick={() => this.Delete(item)}
                        >
                          {""}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

              {!list.length && (
                <tr>
                  <td colSpan={7}>
                    <div className="prop-empty">
                      <div className="prop-empty__icon icon">{""}</div>
                      <div className="fw-bold text-dark mb-1">{t("mkc_empty_title")}</div>
                      <div className="text-12">{t("mkc_empty_desc")}</div>
                      {can("marketing-channels.create") && (
                        <button type="button" className="prop-btn prop-btn--sm mt-3" onClick={this.OpenCreate}>
                          <span className="icon text-12">{""}</span>
                          {t("mkc_add")}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ============================================ render : modal เพิ่ม/แก้ไข */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;
    const code = toCode(form.code);
    // ช่องทางที่ระบบมีโลโก้แบรนด์ให้อยู่แล้ว ไม่ต้องเลือกไอคอนสำรอง
    const hasBrand = !!brandMark(code);
    // อัปโหลดรูปแล้ว = รูปเป็นตัวกำหนดหน้าตาทั้งหมด ไอคอน/สีจึงไม่ได้ใช้และไม่ต้องโชว์
    const useLogo = !!form.logo_url;
    // ค่าที่ preview ใช้ — รูปแบบเดียวกับ record จาก API เพื่อให้วาดด้วยตัวเดียวกับหน้าคิวงาน
    const preview = { logo_url: form.logo_url, code, icon: form.icon, name_th: form.name_th, name_en: form.name_en };

    return (
      <Modal size="lg" show={modal_form} onHide={this.CloseForm} centered contentClassName="border-0 rounded-4 overflow-visible shadow-lg">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("mkc_edit") : t("mkc_add")}</h5>
            <div className="text-secondary text-12">{edit_uid ? t("mkc_edit_desc") : t("mkc_add_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างชิป — เห็นผลทันทีตอนแก้ชื่อ รหัส หรือสี (หน้าคิวงานจะแสดงแบบนี้เป๊ะ) */}
          <div className="d-flex align-items-center gap-3 p-3 mb-4 rounded-4" style={{ background: "#f7faf3", border: "1px solid #e6eae7" }}>
            <div className="mk-ch-swatch" style={{ "--mk-chan-color": form.color }}>
              {this.glyph(preview)}
            </div>
            <div className="min-w-0">
              <div className="fw-bold text-dark text-truncate">{form.name_th || t("mkc_preview_name")}</div>
              <div className="ppl-sub d-flex align-items-center gap-2">
                <span className="pty-code">{code || "code"}</span>
                <span className="text-truncate">{form.name_en || t("mkc_preview_name_en")}</span>
              </div>
            </div>
            <div className="ms-auto d-flex align-items-center gap-1">
              {/* ชิปขนาดจริงที่จะไปโผล่บนแถวของหน้าคิวงาน */}
              <span className="mk-chan" style={{ "--mk-chan-color": form.color }}>
                {this.glyph(preview)}
              </span>
              <span className="mk-chan is-off">{this.glyph(preview)}</span>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="prop-label">
                {t("mkc_name_th")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mkc_name_th_placeholder")}
                value={form.name_th}
                onChange={(e) => this.setForm({ name_th: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("mkc_name_en")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mkc_name_en_placeholder")}
                value={form.name_en}
                onChange={(e) => this.setForm({ name_en: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("mkc_code")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mkc_code_placeholder")}
                value={form.code}
                disabled={!!edit_uid}
                onChange={(e) => this.setForm({ code: toCode(e.target.value) })}
              />
              <div className="text-secondary text-10 mt-1">{edit_uid ? t("mkc_code_locked") : t("mkc_code_hint")}</div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("active") : t("inactive")}
                </span>
              </div>
              <div className="text-secondary text-10">{t("mkc_status_hint")}</div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("mkc_url")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mkc_url_placeholder")}
                value={form.url}
                onChange={(e) => this.setForm({ url: e.target.value })}
              />
              <div className="text-secondary text-10 mt-1">{t("mkc_url_hint")}</div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("description")}</label>
              <textarea
                className="prop-field"
                rows={2}
                style={{ height: "auto", paddingTop: "10px" }}
                placeholder={t("mkc_desc_placeholder")}
                value={form.description}
                onChange={(e) => this.setForm({ description: e.target.value })}
              />
            </div>

            {/* ------------------------------------------------- หน้าตาของช่องทาง
                อัปโหลดโลโก้เองได้ ใช้แทนไอคอน+สีไปเลย — ช่องทางของพันธมิตรหรือ
                เอเจนซี่มักมีโลโก้เป็นรูปอยู่แล้ว การจับคู่ไอคอน+สีให้ใกล้เคียงทำได้ไม่ดีพอ
                อัปโหลดแล้วตัวเลือกไอคอน/สีจะถูกซ่อน เพราะไม่ได้ถูกใช้อีกต่อไป
                ลบรูปเมื่อไรก็กลับมาเลือกได้เหมือนเดิม */}
            <div className="col-12">
              <label className="prop-label">{t("mkc_logo")}</label>
              <div className="mk-upload">
                <div className="mk-upload__preview" style={{ "--mk-chan-color": form.color }}>
                  {this.glyph(preview)}
                </div>

                <div className="flex-grow-1 min-w-0">
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <label className="prop-btn prop-btn--ghost prop-btn--sm mb-0">
                      <span className="icon text-12">{""}</span>
                      {form.logo_url ? t("mkc_logo_change") : t("mkc_logo_upload")}
                      <input type="file" accept={LOGO_ACCEPT} className="d-none" onChange={this.PickLogo} />
                    </label>
                    {!!form.logo_url && (
                      <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.ClearLogo}>
                        <span className="icon text-12">{""}</span>
                        {t("mkc_logo_remove")}
                      </button>
                    )}
                  </div>
                  <div className="text-secondary text-10 mt-2">
                    {form.logo_url ? t("mkc_logo_hint_on") : hasBrand ? t("mkc_logo_hint_brand") : t("mkc_logo_hint_off")}
                  </div>
                </div>
              </div>
            </div>

            {/* ไอคอน + สี — ตัวสำรองเมื่อยังไม่ได้อัปโหลดโลโก้ */}
            {!useLogo && (
              <div className={hasBrand ? "col-12" : "col-md-7"}>
                <label className="prop-label">{t("mkc_color")}</label>
                <div className="mk-colors">
                  {CHANNEL_COLORS.map((color) => (
                    <button
                      key={color}
                      type="button"
                      className={`mk-color ${form.color === color ? "is-on" : ""}`}
                      style={{ "--mk-chan-color": color }}
                      title={color}
                      onClick={() => this.setForm({ color })}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* ไอคอนสำรอง — โผล่เฉพาะช่องทางที่ยังไม่มีทั้งโลโก้ที่อัปโหลดและโลโก้แบรนด์ */}
            {!useLogo && !hasBrand && (
              <div className="col-md-5">
                <label className="prop-label">{t("mkc_icon")}</label>
                <div className="pty-picker">
                  {CHANNEL_ICONS.map((icon) => (
                    <button
                      key={icon}
                      type="button"
                      className={`pty-picker__icon icon ${form.icon === icon ? "is-on" : ""}`}
                      onClick={() => this.setForm({ icon })}
                    >
                      {icon}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="ppl-note mt-4">
            <span className="icon">{""}</span>
            <div>{t("mkc_master_hint")}</div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.Save}>
            <span className="icon text-12">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("marketing_channels")}</h3>
              <div className="text-secondary text-14">{t("mkc_page_desc")}</div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {can("marketing-channels.create") && (
                <button type="button" className="prop-btn" onClick={this.OpenCreate}>
                  <span className="icon text-14">{""}</span>
                  {t("mkc_add")}
                </button>
              )}
            </div>
          </div>

          {this.renderTable()}
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}

export default withRouter(MarketingChannels);
